import { Component, Input, OnInit, OnDestroy, Output, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { Message, SpinnerService } from 'shared-components';
import { AdminService } from "../../../../services/admin.service";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: 'app-asociar-actualizaciones-sw',
    templateUrl: './asociar-actualizaciones.component.html'
})
export class AsociarActualizacionesSwComponent implements OnInit, OnDestroy {

    public denominaciones;
    public actualizacionesString = [];
    public actualizacionesId = [];

    public actualizacionesForm: UntypedFormGroup;

    private paisId;

    public disabledDenominaciones: Subject<boolean> = new Subject();

    private readonly destroy$ = new Subject<void>();

    public itemsPerPage = 5;
    public currentPage = 1;
    public firstItemList = 0;
    public lastItemList = this.itemsPerPage;
    public totalItems = this.actualizacionesString.length;
    public readonly visiblePages = 3;

    @Output() emitActualizaciones = new EventEmitter<any>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvider: DataProvider,
        private readonly _adminService: AdminService
    ) {}

    ngOnInit() {
        this.actualizacionesForm = this._fb.group({
            pais: [''],
            denominaciones: [{value: '', disabled: true}],
        });

        this.actualizacionesForm.get('pais').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pais) => {
            if (pais) {
                this.getDenominacionesByPais(pais.id);
            } else {
                this.disabledDenominaciones.next(true);
                this.denominaciones = [];
                this.actualizacionesForm.get('denominaciones').patchValue('');
                this.actualizacionesForm.get('denominaciones').disable();
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get paises() {
        return this._dataProvider.paises;
    }

    public getDenominacionesByPais(paisId) {
        let filters = {
            paisId,
            existeParametrizadaEnLicencia: true
        };
        this.paisId = paisId;
        this._spinnerService.showSpinner();
        this._adminService.getDenominaciones(filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            if (resp.lista.length > 0) {
                this.denominaciones = resp.lista;
                this.actualizacionesForm.get('denominaciones').enable();
                this.disabledDenominaciones.next(false);
            }
        })
    }

    shareCheckedListDenominaciones(item: any[]) {
        this.actualizacionesForm.get('denominaciones').patchValue(item);
        if (!item) {
            item = [];
        }

        const deleteArrayString = item.map((element) => {
            return {pais: this.actualizacionesForm.get('pais').value.des, denominacion: this.denominaciones.find(x => x.id === element).des}
        });

        const deleteArrayId = item.map((element) => {
            return {paisId: this.actualizacionesForm.get('pais').value.id, denominacionId: this.denominaciones.find(x => x.id === element).id}
        })

        this.actualizacionesString.forEach(actualizacion => {
            if (!deleteArrayString.includes(actualizacion) && this.actualizacionesForm.get('pais').value.des === actualizacion.pais) {
                this.actualizacionesString = this.actualizacionesString.filter(x => x.pais !== actualizacion.pais && x.denominacion !== actualizacion.denominacion);
            }
        });

        this.actualizacionesId.forEach(actualizacion => {
            if (!deleteArrayId.includes(actualizacion) && this.actualizacionesForm.get('pais').value.id === actualizacion.paisId) {
                this.actualizacionesId = this.actualizacionesId.filter(x => x.paisId !== actualizacion.paisId && x.denominacionId !== actualizacion.denominacionId);
            }
        });

        item.forEach(denominacionId => {
            this.actualizacionesString.push({
                pais: this.paises.find(x => x.id === this.actualizacionesForm.get('pais').value.id).des,
                denominacion: this.denominaciones.find(x => x.id === denominacionId).des
            });
            this.actualizacionesId.push({
                paisId: this.paises.find(x => x.id === this.actualizacionesForm.get('pais').value.id).id,
                denominacionId: this.denominaciones.find(x => x.id === denominacionId).id
            });
        });

        this.emitActualizaciones.emit(this.actualizacionesId);

        this.totalItems = this.actualizacionesId ? this.actualizacionesId.length : 0;

        if (this.firstItemList > this.actualizacionesId.length-1 && this.actualizacionesId.length !== 0) {
            this.pageChange(this.currentPage-1);
        } else {
            this.pageChange(1);
        }
    }

    public pageChange(page) {
        this.currentPage = page;
        this.firstItemList = this.itemsPerPage * (page - 1);
        this.lastItemList = this.itemsPerPage * page;
    }
}